import { SvelteFacet } from "../filter/SvelteFacet";
import { isSelected, SvelteFacetValue } from "../filter/SvelteFacetValue";
import { element } from "../util/Utils";
import { events } from "../events";
import { isActive } from "../toggle/Toggle";
import { addCategoryPathToStore, deleteCategoryPathFromStore, emptyCategoryPathStore } from "./categoryPathStore";

const CATEGORY_PATH_FACET_NAME = "kategorien";
const FACET_VALUE_CLASS = "hc_facetValueInput";

function insertClonedBefore(parentNode: Node, cloned: SvelteFacetValue, sibling: Node | null | undefined): void {
  if (cloned.liElem) {
    parentNode.insertBefore(cloned.liElem, sibling ?? null);
  }
}

function handleDeselected(changedValue: SvelteFacetValue, values: SvelteFacetValue[]): void {
  const refinementBarValue = values.find((value) => value.ref === changedValue.id);
  /*                                                                      */
  const unselectedTemplate = values.find((value) => !value.checked && value.ref !== changedValue.id);

  /*                                                                */
  if (unselectedTemplate && changedValue.nba) {
    const parentNode = unselectedTemplate.liElem?.parentNode;
    if (refinementBarValue && parentNode) {
      refinementBarValue.liElem?.remove();
      const cloned = unselectedTemplate.cloneWithData(changedValue.id, changedValue.spanInnerHTML);
      insertClonedBefore(parentNode, cloned, unselectedTemplate.liElem?.nextSibling);
    }
  } else {
    refinementBarValue?.liElem?.remove();
  }
}

function handleSelected(changedValue: SvelteFacetValue, values: SvelteFacetValue[]): void {
  const selectedTemplate = values.find((value) => value.checked);
  const parentNode = selectedTemplate?.liElem?.parentNode;
  if (!selectedTemplate || !parentNode) {
    return;
  }

  removeValueWithRef(values, changedValue.id);
  const cloned = selectedTemplate.cloneWithData(changedValue.id, changedValue.spanInnerHTML);
  cloned.facetValue.addEventListener("click", () => {
    /*                                                                                   */
    cloned.updateTrackingLabelsOnReferenced("deleted", "x_single_top", "list_initial");
  });
  insertClonedBefore(parentNode, cloned, selectedTemplate.liElem?.nextSibling);
}

function syncRefinementBarValues(changedValue: SvelteFacetValue): void {
  const refinementBar = element(".heureka_refinementBar");
  if (!refinementBar) {
    return;
  }

  const refinementBarCategoryPathValues = SvelteFacetValue.factory
    .pickAll(undefined, refinementBar)
    .filter((value) => value.name === CATEGORY_PATH_FACET_NAME);

  if (changedValue.checked === false) {
    handleDeselected(changedValue, refinementBarCategoryPathValues);
  } else {
    handleSelected(changedValue, refinementBarCategoryPathValues);
  }
}

export function syncRefinementBarCategoryPath(refinementBarValues: SvelteFacetValue[]) {
  const categoryPathFacetSelectedValues = SvelteFacet.facetName(CATEGORY_PATH_FACET_NAME)?.selectedValues;
  const categoryPathRefinementBarValues = refinementBarValues.filter(
    (value) => value.name === CATEGORY_PATH_FACET_NAME,
  );
  if (categoryPathFacetSelectedValues && categoryPathRefinementBarValues) {
    const selectedTemplate = categoryPathRefinementBarValues.find((value) => value.checked);
    if (selectedTemplate) {
      const parentNode = selectedTemplate.liElem?.parentNode;
      if (parentNode) {
        categoryPathFacetSelectedValues.forEach((value) => {
          removeValueWithRef(categoryPathRefinementBarValues, value.id);
          const cloned = selectedTemplate.cloneWithData(value.id, value.spanInnerHTML);
          const firstSibling = selectedTemplate.liElem?.nextSibling;
          if (cloned.liElem) {
            parentNode.insertBefore(cloned.liElem, firstSibling);
          }
        });
      }
    }
  }
}

function removeValueWithRef(values: SvelteFacetValue[], ref: string): void {
  const value = values.find((value) => value.ref === ref);
  value?.liElem?.remove();
}

function syncCategoryPathStore() {
  const categoryPathFacet = SvelteFacet.facetName(CATEGORY_PATH_FACET_NAME);
  if (categoryPathFacet) {
    emptyCategoryPathStore();
    categoryPathFacet.values.filter(isSelected).forEach((value) => addCategoryPathToStore(value));
  }
}

function addCategoryPathChangeListener() {
  const categoryPathFacet = SvelteFacet.facetName(CATEGORY_PATH_FACET_NAME);
  if (categoryPathFacet) {
    categoryPathFacet.facet.addEventListener("change", (e) => {
      if (e.target instanceof HTMLElement && e.target.classList.contains(FACET_VALUE_CLASS)) {
        if (isActive("HEUREKA_2117_MOUNT_NBF_DIRECTLY_IN_REFINEMENT_BAR")) {
          const targetValue = SvelteFacetValue.factory.declare(e.target);
          if (targetValue) {
            if (targetValue.checked) {
              addCategoryPathToStore(targetValue);
            } else {
              deleteCategoryPathFromStore(targetValue.id);
            }
          }
        } else {
          const targetValue = SvelteFacetValue.factory.declare(e.target);
          if (targetValue) {
            syncRefinementBarValues(targetValue);
          }
        }
      }
    });
  }
}

export function registerCategoryPathValuesSelection() {
  events.onFilterSectionLoaded(syncCategoryPathStore);
  events.onFilterSectionLoaded(addCategoryPathChangeListener);
}
